// extracted by mini-css-extract-plugin
module.exports = {"body":"style_body__m3Lbr"};